import { HubItemKind } from "client/Api/Hub/hubItemCategories";
import { ReactElement } from "react";
import {
	EventCommentNotificationDataViewModel,
	EventCommentReactionNotificationDataViewModel
} from "client/Api/Notifications/notifications";
import { HubDetailsDialog } from "client/Features/Hub/HubDetailsDialog";

export type EventCommentActivityInvocationProps = {
	data: EventCommentNotificationDataViewModel
		| EventCommentReactionNotificationDataViewModel;
	onDismiss: () => void;
};

export const EventCommentActivityInvocation = (props: EventCommentActivityInvocationProps): ReactElement => {
	const {
		data,
		onDismiss
	} = props;

	const {
		eventId,
		commentId
	} = data;

	return (
		<HubDetailsDialog
			itemKind={HubItemKind.Event}
			id={eventId}
			commentId={commentId}
			onClose={onDismiss}
		/>
	);
};

EventCommentActivityInvocation.displayName = "EventCommentActivityInvocation";